import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function Decoration() {
  const [listedeco, setListDeco] = useState([]);

  const [decorations, setDecorations] = useState([]);
  const [selectedDecoration, setSelectedDecoration] = useState('');
  const [eligiblePersonnels, setEligiblePersonnels] = useState([]);

  useEffect(() => {
    // Récupérer les décorations lors du montage du composant
    const fetchDecorations = async () => {
      try {
        const response = await axios.get('/decoration');
        setDecorations(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des décorations:', error);
      }
    };

    fetchDecorations();
  }, []);

  const handleDecorationChange = async (event) => {
    toast.warn('Veuillez patienter pour lister les personnels éligibles');
    const decorationId = event.target.value;
    setSelectedDecoration(decorationId);

    // Récupérer les personnels éligibles pour la décoration sélectionnée
    if (decorationId) {
      try {
        const response = await axios.get('/personnel/api/x/eligible-decorations', {
          params: { decorationId },
        });

        setEligiblePersonnels(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des personnels éligibles:', error);
      }
    } else {
      setEligiblePersonnels([]);
    }
  };

  useEffect(() => {
    axios.get('/decoration').then((res) => {
      setListDeco(res.data);
    });
  }, []);

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col">
          <h2>Sélectionnez une décoration pour voir les personnels éligibles</h2>

          <form>
            <select className="form-control " value={selectedDecoration} onChange={handleDecorationChange}>
              <option value="">-- Sélectionnez une décoration --</option>
              {decorations.map((decoration) => (
                <option key={decoration.id} value={decoration.id}>
                  {decoration.name}
                </option>
              ))}
            </select>
          </form>
          {'Résultats trouvés : ' + ' ' + eligiblePersonnels.length}
          {eligiblePersonnels.length > 0 ? (
            <table className="table table-striped mt-5">
              <thead className="thead-dark">
                <tr>
                  <th>Grade</th>
                  <th>Nom et prénoms</th>
                  <th>Date de naissance</th>
                  <th>Date de recrutement</th>
                  <th>Décoration</th>
                </tr>
              </thead>
              <tbody>
                {eligiblePersonnels.map((personnel) => (
                  <tr key={personnel.personnelId}>
                    <td>{personnel.personnelGrade}</td>
                    <td>{personnel.personnelName}</td>
                    <td>{personnel.personnelDatenaisse}</td>
                    <td>{personnel.personnelDaterecrute}</td>
                    <td>{personnel.decorationEligible}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="bg-warning p-3 m-3 ">Liste Décoration</div>
      <Link to="/creatdecoration" className="btn btn-primary m-3 ">
        Nouveau Décoration
      </Link>
      <table className="table table-border table-sm">
        <thead className="thead-dark">
          <tr>
            <th>Decoration</th>
            <th>Libelle</th>
            <th>Age</th>
            <th>Année de service</th>
          </tr>
        </thead>
        <tbody>
          {listedeco.map((listedeco, key) => {
            return (
              <tr key={key}>
                <td> {listedeco.name} </td>
                <td> {listedeco.libelle} </td>
                <td> {listedeco.age} </td>
                <td> {listedeco.anneedeservice} </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Decoration;
